/**
 * Detects iOS environment with focused detection on iOS, Safari and WebView
 * @returns Object with focused iOS environment information
 */
export function detectIOSEnvironment() {
	const userAgent = navigator.userAgent;
	const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !("MSStream" in window);

	const isSafari = isIOS && /Safari/i.test(userAgent) && !/(Chrome|CriOS|FxiOS|OPiOS)/i.test(userAgent);
	const isChrome = isIOS && /CriOS/.test(userAgent);
	const isFirefox = isIOS && /FxiOS/.test(userAgent);
	const isFacebookApp = /FBAN|FBAV/.test(userAgent);
	const isInstagramApp = /Instagram/.test(userAgent);

	const isWebView =
		isIOS &&
		!isSafari &&
		!isChrome &&
		!isFirefox &&
		(isFacebookApp || isInstagramApp || (window as any).webkit?.messageHandlers !== undefined);

	return {
		isIOS,
		isSafari,
		isWebView,
	};
}
